import { Link } from 'react-router-dom';
import { FC } from 'react';
import Aside from '../layout/asaid.component';
import Header from '../layout/header.component';
import Footer from '../layout/footer.component';
import Icon from '../forms/icon.component';
import TemplateCard from './cards.component';

interface PanelItem {
  to: string;
  type: string;
  title: string;
  description: string;
  logoSrc: string;
  imageHeader: boolean;
  srcImage: string;
}

interface ChannelOrTemplatePanelProps {
  title: string;
  subtitle: React.ReactNode;
  items: PanelItem[];
  links: { to: string; label: string; icon: string }[];
}

const ChannelOrTemplatePanel: FC<ChannelOrTemplatePanelProps> = ({
  title,
  subtitle,
  items,
  links
}) => {
  return (
    <div className="page d-flex flex-row flex-column-fluid">
      <Aside />
      <div className="wrapper d-flex flex-column flex-row-fluid" id="kt_wrapper">
        <Header />
        <div className="content fs-6 d-flex flex-column flex-column-fluid" id="kt_content">
          <div className="container-xxl">
            <div className="card mb-10 mb-xxl-8">
              <div className="card-body p-0">
                <div className="d-flex flex-column flex-sm-row mb-6">
                  <div className="position-absolute rounded h-sm-125px h-150px d-flex flex-row-fluid w-100 bgi-no-repeat bgi-position-y-top bgi-size-cover profile-bg"></div>
                  <div className="d-flex flex-column position-absolute ps-8 pt-8 top-0">
                    <div className="d-flex align-items-center mb-4 ms-5">
                      <Icon icon="ki-abstract-28" size="fs-3x" type="white" clasName="mt-20" />
                      <span className="ms-3 fs-2x text-primary fw-bolder">{title}</span>
                    </div>
                    <div className="flex-wrap fw-semibold fs-6 mb-4 ps-sm-17 ps-md-12 ps-lg-10 ps-16 ms-9">
                      {links.map((link) => (
                        <Link
                          key={link.to}
                          className="btn btn-flex btn-flush btn-color-white opacity-75-hover me-5 flex-shrink-0"
                          to={link.to}
                        >
                          <Icon icon={link.icon} size="fs-6" clasName="fs-6 me-2" />
                          {link.label}
                        </Link>
                      ))}
                    </div>
                  </div>
                  <div className="d-flex flex-column flex-xl-row mt-sm-20 pt-sm-20 w-100 me-9 px-9 px-sm-0 ms-15">
                    <p className="fs-6 text-dark flex-grow-1 pe-4 pt-4">{subtitle}</p>
                    <div className="pt-xl-4 flex-shrink-0"></div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row row-cols-1 row-cols-md-3 g-4">
              {items.map((item, index) => (
                <TemplateCard
                  key={item.title}
                  type={item.type}
                  to={item.to}
                  title={item.title}
                  description={item.description}
                  logoSrc={item.logoSrc}
                  index={index + 1}
                  imageHeader={item.imageHeader}
                  srcImage={item.srcImage}
                />
              ))}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ChannelOrTemplatePanel;
